import GeneralModal from '@gp/components/GeneralModal';
import { FILE_TYPES_MAP } from '@gp/constants/const';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
import { downloadScheduleMonthlyList, scheduleListDownload } from '@gp/services/overview';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import DownloadBox from '../DownloadBox';

import type { IBaseProps } from '@home/types/common';

interface IDownloadFormModel {
  infoPoint: string[] | undefined;
  milestoneType: string | undefined;
  fileType: string | undefined;
}

interface IDownloadModalProps extends IBaseProps {
  tab: ScheduleTabTypes;
  segment: ScheduleSegmentTypes;
  fetchParams: Record<string, any>;
  visible: boolean;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDownloading?: React.Dispatch<React.SetStateAction<boolean>>;
}

const DownloadModal: React.FC<IDownloadModalProps> = (props) => {
  const { style, className, tab, segment, fetchParams, visible, setVisible, setIsDownloading } =
    props;

  const { isDownloading, handleDownload } = useDownload({
    csvDownloadLogKey: 'PIPELINE_DASHBOARD_SCHEDULE_CSV_SUBMIT',
    excelDownloadLogKey: 'PIPELINE_DASHBOARD_SCHEDULE_EXCEL_SUBMIT',
    downloadService: createDownloadService(
      tab === 'calendar-card' ? scheduleListDownload : downloadScheduleMonthlyList,
    ),
  });

  const [formModel, setFormModel] = useState<IDownloadFormModel | null>(null);

  const handleConfirm = () => {
    const { fileType, infoPoint, milestoneType } = formModel || {};
    const fileTypeTmp = fileType || FILE_TYPES_MAP.CSV;
    handleDownload({
      fileType: fileTypeTmp,
      metrics: infoPoint,
      file_type: Number.parseInt(fileTypeTmp, 10),
      schedule_req: {
        ...fetchParams,
        // 1: Official Review, 2: All Milestone, 3: Launching Schedule
        type: 2,
        category: milestoneType === '2' ? [] : [milestoneType],
      },
    });
    setVisible?.(false);
  };

  useEffect(() => {
    setIsDownloading?.(isDownloading);
  }, [isDownloading]);

  return (
    <GeneralModal
      style={style}
      className={classnames(
        'dbg-dashboard-schedule-calendar-download-modal globalpedia-custom-scrollbar',
        className,
      )}
      title="Download Settings"
      isFooter
      modalSize={662}
      visible={visible}
      disabledConfirm={!formModel?.infoPoint?.length}
      onConfirm={handleConfirm}
      onClose={() => {
        setVisible?.(false);
      }}
      content={<DownloadBox currentSegment={segment} onChange={setFormModel} />}
    />
  );
};

export default DownloadModal;
